import script from "./FounderCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./FounderCard.vue?vue&type=script&setup=true&lang=ts"

import "./FounderCard.vue?vue&type=style&index=0&id=f543b764&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f543b764"]])

export default __exports__